import CommonTNTControlBase from '../../../util/CommonTNTControlBase'

class SetupBaseController extends CommonTNTControlBase {
  /*@ngInject*/
  constructor(Auth, $state, User, Service, Modal, $translate, $stateParams) {
    super(Auth, $state, User, Service, Modal, $translate, $stateParams)


    this.errors = {}
    this.model = {}
    this.loading = false
    this.errorMessage = ''
    this.toggleSwitchUI = {
      size: 'small',
      label: {
        on: 'Yes',
        off: 'No'
      },
      onColor: 'success',
      offColor: 'danger'
    }

  }

  askCreate() {

    this.Modal.confirm({
      header: this.$translate.instant('setup.create_another_title'),
      message: this.$translate.instant('setup.create_another_message'),
      callback: ({
        modal,
        $scope
      }) => {
        this.reset()
        modal.close()
      },
      negative: ({
        modal,
        $scope
      }) => {
        modal.close()
        window.history.go(-1)
      },
      type: 'primary',
      buttons: ['common.yes', 'common.no']
    })
  }

  validate() {
    this.clearErrors()

    for (let key in this.model) {
      if (!this.model[key]) {
        this.addError(key, key + ' is mandatory')
      }
    }

    return Object.keys(this.errors).length <= 0
  }

  clearErrors() {
    this.errors = {}
    this.errorMessage = ''
  }

  addError(id, message) {
    this.errors[id] = message
  }
}

export default SetupBaseController;


// WEBPACK FOOTER //
// ./client/app/components/tnt_control/component/setup/common/setup.base.controller.js